import * as React from 'react';
import { Button, TextArea, Segment, Grid, Input, Form } from 'semantic-ui-react';

export interface LoginWithTokenProps {
  onLoginClick(token: string, expertId: string): void;
}
const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
export interface LoginWithTokenState {
  token: string;
  expertId: string;
}

export class LoginWithToken extends React.Component<LoginWithTokenProps, LoginWithTokenState> {

  constructor(props: LoginWithTokenProps, state: LoginWithTokenState) {
    super(props, state);
    this.state = {
      token: '',
      expertId: '',
    };
  }

  onLogin = () => {
    if (this.state.token) {
      this.props.onLoginClick(this.state.token, this.state.expertId);
    }
  }

  onTokenValueChange = (textAreaProps: React.SyntheticEvent<HTMLTextAreaElement>) => {
    this.setState({ token: textAreaProps.currentTarget.value });
  }

  onExpertIdChange = (expertIdInput: React.SyntheticEvent<HTMLInputElement>) => {
    this.setState({ expertId: expertIdInput.currentTarget.value });
  }


  isExpertIdValid = () => {
    if (this.state.expertId && this.state.expertId.match(uuidPattern)) {
      return true;
    }
    return false;
  }

  isValidData = () => {
    if (this.state.expertId && this.isExpertIdValid()) {
      return true;
    }
    return false;
  }


  onClear = () => {
    this.setState({ token: '' });
  }

  render() {
    return (
      <Segment basic={true}>
        <Form>
          <Grid>
            <Grid.Row>
              <Grid.Column width={3}>
                Expert Id (uuid format)
            </Grid.Column>
              <Grid.Column width={13}>
                <Input
                  fluid={true}
                  id="expertId"
                  placeholder="Enter expert id here" 
                  value={this.state.expertId}
                  onChange={this.onExpertIdChange}
                />
                {
                  this.state.expertId && !this.isExpertIdValid() 
                  ? <span className="errorInput">
                  Enter valid expert id. This must be in uuid format</span> : null
                }
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={3}>
                Token
            </Grid.Column>
              <Grid.Column width={13}>
                <TextArea
                  placeholder="Enter auth token here" 
                  rows={10}
                  value={this.state.token}
                  onChange={this.onTokenValueChange}
                  id="authToken"
                />
              </Grid.Column>
            </Grid.Row>

            <Grid.Row textAlign="right">
              <Grid.Column>
                <Button onClick={this.onClear}> Clear
              </Button>
              </Grid.Column>
              <Grid.Column>
                <Button onClick={this.onLogin} disabled={!this.isValidData()} primary={true}> Login
              </Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
      </Segment>
    );
  }
}







// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Login/LoginWithToken.tsx